import styled from 'styled-components/macro';

const UserBlock = styled.div`
  display: flex;
  align-items: flex-end;
  height: 56px;
  margin-bottom: 16px;
`;

export default UserBlock;
